module.exports = __webpack_public_path__ + "static/media/Tom.224b735f.png";